var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('PortalTarget',{attrs:{"name":"modal","slim":"","target-el":"#modalHost"}}),_c('FrkGtmTracking'),_c('FrkVersionUpgrader'),_c('UserNotificationsContainer'),_c('UserTermsModal'),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }